/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import useStoneEle from '../hooks/useStoneEle';
import useProDataTrend from '../hooks/useProDataTrend';
import { BarEchartMul } from '@/components/page-echarts';
import hyRequest from '@/service';
import localCache from '@/utils/localCache';
// window.toDetail = function (params) {
// }
export default defineComponent({
  name: 'ProdAggregateAccount',
  components: {
    BarEchartMul: BarEchartMul
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props) {
    var emptyStringFormat = useEmptyStringFormat();
    var switchClick = function switchClick() {
      window.location.href = "/table/sandMachineHour.html?factoryId=".concat(localCache.getItem('factoryId'));
    };
    // 选择日期
    var confrimDate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.date = val;
              getStoneEleByDateTypeAsync();
              getProDataTrendAsync();
              getProDataYearTrendAsync();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confrimDate(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var dateRef = ref();
    var params = ref({
      type: props.type,
      date: dayjs().format('YYYY/MM/DD')
    });
    watch(function () {
      return props.type;
    }, function (newVal) {
      var _dateRef$value;
      params.value.type = newVal;
      params.value.date = dayjs().format('YYYY/MM/DD');
      //把所以日期控件的日期变为当前最新日期
      (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
      proDataTrend.value.splice(0);
      proDataYearTrend.value.splice(0);
      getStoneEleByDateTypeAsync();
      getProDataTrendAsync();
      getProDataYearTrendAsync();
    });
    var title = computed(function () {
      var text = '';
      if (props.type === 1) {
        text = '周';
      }
      if (props.type === 2) {
        text = '月';
      }
      if (props.type === 3) {
        text = '年度';
      }
      return text;
    });
    var _useStoneEle = useStoneEle(params),
      _useStoneEle2 = _slicedToArray(_useStoneEle, 2),
      stoneEle = _useStoneEle2[0],
      getStoneEleByDateTypeAsync = _useStoneEle2[1];
    var _useProDataTrend = useProDataTrend(params),
      _useProDataTrend2 = _slicedToArray(_useProDataTrend, 4),
      proDataTrend = _useProDataTrend2[0],
      proDataYearTrend = _useProDataTrend2[1],
      getProDataTrendAsync = _useProDataTrend2[2],
      getProDataYearTrendAsync = _useProDataTrend2[3];
    var factoryID = ref(0);
    onMounted(function () {
      hyRequest.post({
        url: '/factoryapp/getFactoryInfo'
      }).then(function (data) {
        factoryID.value = data.factory;
      });
      getStoneEleByDateTypeAsync();
      getProDataTrendAsync();
      getProDataYearTrendAsync();
    });
    var summaryData = computed(function () {
      var text = '';
      if (props.type === 1) {
        text = '周';
      }
      if (props.type === 2) {
        text = '月';
      }
      if (props.type === 3) {
        text = '年';
      }
      return [{
        num: stoneEle.value.mainPro,
        desc: "\u4E3B\u673A".concat(text, "\u4EA7\u91CF/\u5428")
      }, {
        num: stoneEle.value.stonePro,
        desc: "\u5236\u7802".concat(text, "\u4EA7\u91CF/\u5428")
      }, {
        num: stoneEle.value.electric,
        desc: "".concat(text, "\u8017\u7535\u91CF/\u5EA6")
      }, {
        num: stoneEle.value.tonEle,
        desc: "\u5428\u8017\u7535/\u5EA6"
      }];
    });
    var mainPro = computed(function () {
      var lineData1 = proDataTrend.value.map(function (item) {
        return item.mainPro;
      });
      var lineData2 = proDataTrend.value.map(function (item) {
        return item.stonePro;
      });
      var lineData3 = proDataTrend.value.map(function (item) {
        return item.electric;
      });
      var lineData4 = proDataTrend.value.map(function (item) {
        return item.tonEle;
      });
      var xLabels = proDataTrend.value.map(function (item) {
        return item.time;
      });
      var legendData = ['主破产量', '制砂产量', '耗电量', '吨耗电'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2, lineData3, lineData4],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324', '#00B2F4'],
        grid: {
          left: 70,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(['主破产量', '制砂产量'].includes(item.seriesName) ? '吨' : '度', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var mainProYear = computed(function () {
      var lineData1 = proDataYearTrend.value.map(function (item) {
        return item.mainPro;
      });
      var lineData2 = proDataYearTrend.value.map(function (item) {
        return item.stonePro;
      });
      var lineData3 = proDataYearTrend.value.map(function (item) {
        return item.electric;
      });
      var lineData4 = proDataYearTrend.value.map(function (item) {
        return item.tonEle;
      });
      var xLabels = proDataYearTrend.value.map(function (item) {
        return item.time;
      });
      var legendData = ['主破产量', '制砂产量', '耗电量', '吨耗电'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2, lineData3, lineData4],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324', '#00B2F4'],
        grid: {
          left: 70,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(['主破产量', '制砂产量'].includes(item.seriesName) ? '吨' : '度', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    return {
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      stoneEle: stoneEle,
      summaryData: summaryData,
      mainPro: mainPro,
      mainProYear: mainProYear,
      title: title,
      params: params,
      confrimDate: confrimDate,
      dateRef: dateRef,
      factoryID: factoryID
    };
  }
});